<template>
  <a-card>
    <DocumentsHeader
      :uploadfn="addedDocument"
      @clear="clearHeader"
      @toggleDelete="showChecks = !showChecks"
      :confirmDelete="deleteDocuments"
    />

    <CheckboxWrapper
      v-for="(doc, i) in documentList"
      :key="doc.id"
      :value="doc.id"
      :show-check="showChecks"
      @toggle="selectFileDelete"
    >
      <a class="docdownload" :href="getLink(doc)" @click="(e) => openPdf(e, doc)">
        <a-card nopad class="d-flex hover justify-space-between">
          <div class="d-flex align-center">
            <span class="subtitle-2 pa-3">{{ doc.display_name || doc.name }}</span>
            <v-btn class="editbtn" icon small @click="(e) => editDocument(e, doc)">
              <v-icon small>edit</v-icon>
            </v-btn>
          </div>
          <div class="caption pa-3">
            <span>{{ doc.user_name }}</span>
            <span class="mx-2">|</span>
            <span>{{ formatDate(doc.uploaded_date) }}</span>
          </div>
        </a-card>
      </a>
    </CheckboxWrapper>

    <edit-document-dialog v-model="editDialog" :editData="editFocus" @update="updateDocument" />
    <d-no-display v-if="documentList.length === 0" label="(No documents to display)" />
  </a-card>
</template>

<script>
import dateFormat from "@/services/format";
import { DocumentsHeader } from "@/modules/media.documents";

export default {
  components: {
    DocumentsHeader,
  },
  data() {
    return {
      showChecks: false,
      checkedItems: [],
      documentList: [],
      editDialog: false,
      editFocus: {},
    };
  },
  computed: {
    quoteId() {
      return this.$store.getters["QuoteStore/quote_id"];
    },
  },
  methods: {
    formatDate(date) {
      return date ? dateFormat.formatDate(dateFormat.convertDate(date)) : "(unknown)";
    },
    clearHeader() {
      this.showChecks = false;
      this.checkedItems = [];
    },
    addedDocument(docList) {
      return Promise.all(
        docList.map((doc) => {
          return this.uploadDocument(doc);
        })
      )
        .then((docBulk) => {
          this.$root.$success(`Uploaded documents`);
          docBulk.forEach((doc) => {
            doc.user_name = this.$store.getters["AccountStore/name"];
            this.documentList.push(doc);
          });
        })
        .catch((err) => {
          this.$root.$error(err);
        });
    },
    uploadDocument(doc) {
      return this.$store.dispatch("StorageStore/uploadFile", { name: doc.name, file: doc.upload }).then((data) => {
        return this.$store.dispatch("QuoteStore/addDocument", {
          origin_id: this.quoteId,
          name: doc.name,
          key: data.key,
        });
      });
    },
    deleteDocuments() {
      return this.$store
        .dispatch("QuoteStore/deleteDocumentList", this.checkedItems)
        .then((v) => {
          this.$root.$success("Deleted documents");
          var vm = this;
          this.documentList = this.documentList.filter(function (item) {
            return vm.checkedItems.indexOf(item.id) === -1;
          });
          this.clearHeader();
        })
        .catch((err) => this.$root.$error(err));
    },
    selectFileDelete({ check, value }) {
      if (check) {
        this.checkedItems.push(value);
      } else {
        const index = this.checkedItems.findIndex((x) => x.id === value);
        this.checkedItems.splice(index, 1);
      }
    },
    getLink(doc) {
      return this.$store.getters["host"] + doc.src;
    },
    openPdf(event, doc) {
      if (doc.mimetype.includes("pdf")) {
        event.preventDefault();
        this.$store.dispatch("openPdf", { ...doc, link: this.getLink(doc) });
      }
    },
    editDocument(event, doc) {
      event.preventDefault();
      event.stopPropagation();
      this.editDialog = true;
      this.editFocus = doc;
    },
    updateDocument(data) {
      let source = this.documentList.find((item) => item.id === data.id);
      this.editDialog = false;
      this.$root.$loading.open("Updating image");

      this.$store
        .dispatch("QuoteStore/updateDocument", {
          ...data,
          old_name: source.display_name,
          dependent_id: this.quoteId,
        })
        .then((v) => {
          let source = this.documentList.find((item) => item.id === data.id);
          source.display_name = data.display_name;
          this.$root.$loading.end();
        })
        .catch((err) => this.$root.$error(err));
    },
  },
  mounted() {
    this.$store
      .dispatch("QuoteStore/getDocumentList", this.quoteId)
      .then((list) => {
        this.documentList = list;
      })
      .catch((err) => this.$root.$error(err));
  },
};
</script>
